/* eslint-disable */
// HISTÓRICO CONGELADO de F3d (useGestionCalcsIngresos): copia literal de la lógica de INGRESOS de gestión y contenidos del hook
// src/pages/ERv2/hooks/useGestionCalcs.js anterior a F3d, convertida en funciones puras (reciben lo que el hook usaba del
// closure). Producción lo usa para los meses < 2026-10 (corteHistorico.js). No editar.
import { parseLocalYMD } from "../../fechasFuturosPanel";
import { getCuotasFacturadasPorMes } from "../../../pages/ERv2/estadoResultadosER";

const fechaLocalDeNegocio = (fechaStr) => parseLocalYMD(fechaStr) || new Date(NaN);

const contenidosVigenteEnMes = (negocio, year, monthIndex) => {
  const contInicio = negocio.contenidos_fecha_inicio ? new Date(negocio.contenidos_fecha_inicio + "T00:00:00") : null;
  const contFin = negocio.contenidos_fecha_fin ? new Date(negocio.contenidos_fecha_fin + "T00:00:00") : null;
  const slotDate = new Date(year, monthIndex, 1);
  return (!contInicio || slotDate >= contInicio) && (!contFin || slotDate <= contFin);
};

export const detalleGestionContenidosHistorico = ({ negocios, clientes, edificios, selectedYear, pais, convertirAMonedaLocal }) => {
    const detalle = Array(12)
      .fill()
      .map(() => []);
    negocios.forEach((negocio) => {
      if (negocio.eliminada || negocio.estado !== "Activo" || !negocio.fecha_inicio) return;
      const fechaInicio = fechaLocalDeNegocio(negocio.fecha_inicio);
      const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
      if (plazoMeses === 0) return;
      const fechaFin = new Date(fechaInicio);
      fechaFin.setMonth(fechaInicio.getMonth() + plazoMeses);
      fechaFin.setDate(fechaFin.getDate() - 1);
      const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
      const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
      const contenidosUnitario = negocio.incluye_contenidos ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;
      let nombreReferencia = `ID ${negocio.referencia_id}`;
      if (negocio.tipo_vertical === "TD" && clientes[negocio.referencia_id]) {
        nombreReferencia = clientes[negocio.referencia_id].nombre;
      } else if (negocio.tipo_vertical === "EO" && edificios[negocio.referencia_id]) {
        nombreReferencia = edificios[negocio.referencia_id]?.edificio;
      }
      // ── Modo "facturado real": mostrar el line item solo en los meses donde hay factura ──
      const cuotasFacturadas = getCuotasFacturadasPorMes(negocio, selectedYear);
      if (cuotasFacturadas) {
        cuotasFacturadas.forEach((slot, m) => {
          if (slot.gestion === 0 && slot.contenidos === 0) return;
          const gestionLocal = convertirAMonedaLocal(
            gestionUnitario * pantallas * slot.gestion,
            negocio.moneda_gestion,
            pais,
            negocio.id,
            m + 1,
            selectedYear,
            slot.fechaFactura
          );
          const contenidosLocal = convertirAMonedaLocal(
            contenidosUnitario * pantallas * slot.contenidos,
            negocio.moneda_contenidos,
            pais,
            negocio.id,
            m + 1,
            selectedYear,
            slot.fechaFactura
          );
          detalle[m].push({
            id: negocio.id,
            tipo: negocio.tipo_vertical,
            nombre: nombreReferencia,
            pantallas,
            cuotasFacturadas: Math.max(slot.gestion, slot.contenidos, 1),
            facturaFecha: slot.fechaFactura,
            gestionUnitario,
            gestionMoneda: negocio.moneda_gestion,
            contenidosUnitario,
            contenidosMoneda: negocio.moneda_contenidos,
            totalLocal: gestionLocal + contenidosLocal,
          });
        });
        return;
      }
      for (let m = 0; m < 12; m++) {
        const ultimoDiaMes = new Date(selectedYear, m + 1, 0);
        if (fechaInicio <= ultimoDiaMes) {
          const gestionLocal = convertirAMonedaLocal(
            gestionUnitario * pantallas,
            negocio.moneda_gestion,
            pais,
            negocio.id,
            m + 1,
            selectedYear
          );
          let contenidosLocal = 0;
          if (contenidosUnitario > 0 && contenidosVigenteEnMes(negocio, selectedYear, m)) {
            contenidosLocal = convertirAMonedaLocal(
              contenidosUnitario * pantallas,
              negocio.moneda_contenidos,
              pais,
              negocio.id,
              m + 1,
              selectedYear
            );
          }
          detalle[m].push({
            id: negocio.id,
            tipo: negocio.tipo_vertical,
            nombre: nombreReferencia,
            pantallas,
            gestionUnitario,
            gestionMoneda: negocio.moneda_gestion,
            contenidosUnitario,
            contenidosMoneda: negocio.moneda_contenidos,
            totalLocal: gestionLocal + contenidosLocal,
          });
        }
      }
    });
    return detalle.map((mes) =>
      mes.sort((a, b) => {
        if (a.tipo !== b.tipo) return a.tipo === "EO" ? -1 : 1;
        return a.nombre.localeCompare(b.nombre);
      })
    );
};

export const ingresosGestionContenidosMensualHistorico = ({ negocios, selectedYear, currentYear, pais, convertirAMonedaLocal, costosGestionData }) => {
    const mapa = Array(12).fill(0);
    negocios.forEach((negocio) => {
      if (negocio.eliminada || negocio.estado !== "Activo" || !negocio.fecha_inicio) return;
      const fechaInicio = fechaLocalDeNegocio(negocio.fecha_inicio);
      const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
      if (plazoMeses === 0) return;
      const fechaFin = new Date(fechaInicio);
      fechaFin.setMonth(fechaInicio.getMonth() + plazoMeses);
      fechaFin.setDate(fechaFin.getDate() - 1);
      const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
      const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
      const contenidosUnitario = negocio.incluye_contenidos ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;
      // ── Modo "facturado real": si meses_facturacion tiene entries, asignar al mes de facturafecha ──
      const cuotasFacturadas = getCuotasFacturadasPorMes(negocio, selectedYear);
      if (cuotasFacturadas) {
        cuotasFacturadas.forEach((slot, m) => {
          if (slot.gestion === 0 && slot.contenidos === 0) return;
          const fechaParaUF = slot.fechaFactura;
          let ingresoLocal = 0;
          if (slot.gestion > 0 && gestionUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              gestionUnitario * pantallas * slot.gestion,
              negocio.moneda_gestion,
              pais,
              negocio.id,
              m + 1,
              selectedYear,
              fechaParaUF
            );
          }
          if (slot.contenidos > 0 && contenidosUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              contenidosUnitario * pantallas * slot.contenidos,
              negocio.moneda_contenidos,
              pais,
              negocio.id,
              m + 1,
              selectedYear,
              fechaParaUF
            );
          }
          mapa[m] += ingresoLocal;
        });
        return;
      }
      const getFechaFactura = (mesIndex) => {
        const registro = costosGestionData.find(
          (c) =>
            Number(c.negocio_id) === negocio.id &&
            Number(c.mes) === mesIndex + 1 &&
            Number(c.ano) === currentYear &&
            c.fecha_factura
        );
        return registro?.fecha_factura?.split("T")[0] || null;
      };
      for (let m = 0; m < 12; m++) {
        const ultimoDiaMes = new Date(selectedYear, m + 1, 0);
        if (fechaInicio <= ultimoDiaMes) {
          const fechaFactura = getFechaFactura(m);
          const fechaParaUF = fechaFactura || ultimoDiaMes.toISOString().split("T")[0];
          let ingresoLocal = 0;
          if (gestionUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              gestionUnitario * pantallas,
              negocio.moneda_gestion,
              pais,
              negocio.id,
              m + 1,
              selectedYear,
              fechaParaUF
            );
          }
          if (contenidosUnitario > 0 && contenidosVigenteEnMes(negocio, selectedYear, m)) {
            ingresoLocal += convertirAMonedaLocal(
              contenidosUnitario * pantallas,
              negocio.moneda_contenidos,
              pais,
              negocio.id,
              m + 1,
              selectedYear,
              fechaParaUF
            );
          }
          mapa[m] += ingresoLocal;
        }
      }
    });
    return mapa;
};

export const ingresosGestionContenidosMensualAnoAnteriorHistorico = ({ negocios, añoAnteriorGestion, pais, convertirAMonedaLocal }) => {
    const mapa = Array(12).fill(0);
    negocios.forEach((negocio) => {
      if (negocio.eliminada || negocio.estado !== "Activo" || !negocio.fecha_inicio) return;
      const fechaInicio = fechaLocalDeNegocio(negocio.fecha_inicio);
      const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
      if (plazoMeses === 0) return;
      const fechaFin = new Date(fechaInicio);
      fechaFin.setMonth(fechaInicio.getMonth() + plazoMeses);
      fechaFin.setDate(fechaFin.getDate() - 1);
      const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
      const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
      const contenidosUnitario = negocio.incluye_contenidos ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;
      // ── Modo "facturado real" ──
      const cuotasFacturadas = getCuotasFacturadasPorMes(negocio, añoAnteriorGestion);
      if (cuotasFacturadas) {
        cuotasFacturadas.forEach((slot, m) => {
          if (slot.gestion === 0 && slot.contenidos === 0) return;
          let ingresoLocal = 0;
          if (slot.gestion > 0 && gestionUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              gestionUnitario * pantallas * slot.gestion,
              negocio.moneda_gestion,
              pais,
              negocio.id,
              m + 1,
              añoAnteriorGestion,
              slot.fechaFactura
            );
          }
          if (slot.contenidos > 0 && contenidosUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              contenidosUnitario * pantallas * slot.contenidos,
              negocio.moneda_contenidos,
              pais,
              negocio.id,
              m + 1,
              añoAnteriorGestion,
              slot.fechaFactura
            );
          }
          mapa[m] += ingresoLocal;
        });
        return;
      }
      for (let m = 0; m < 12; m++) {
        const ultimoDiaMes = new Date(añoAnteriorGestion, m + 1, 0);
        if (fechaInicio <= ultimoDiaMes) {
          const fechaParaUF = ultimoDiaMes.toISOString().split("T")[0];
          let ingresoLocal = 0;
          if (gestionUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              gestionUnitario * pantallas,
              negocio.moneda_gestion,
              pais,
              negocio.id,
              m + 1,
              añoAnteriorGestion,
              fechaParaUF
            );
          }
          if (contenidosUnitario > 0 && contenidosVigenteEnMes(negocio, añoAnteriorGestion, m)) {
            ingresoLocal += convertirAMonedaLocal(
              contenidosUnitario * pantallas,
              negocio.moneda_contenidos,
              pais,
              negocio.id,
              m + 1,
              añoAnteriorGestion,
              fechaParaUF
            );
          }
          mapa[m] += ingresoLocal;
        }
      }
    });
    return mapa;
};

export const ingresosGestionContenidosMensualChileHistorico = ({ negocios, selectedYear, convertirAMonedaLocal }) => {
    const mapa = Array(12).fill(0);
    negocios.forEach((negocio) => {
      if (negocio.eliminada || negocio.estado !== "Activo" || !negocio.fecha_inicio) return;
      const fechaInicio = fechaLocalDeNegocio(negocio.fecha_inicio);
      const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
      if (plazoMeses === 0) return;
      const fechaFin = new Date(fechaInicio);
      fechaFin.setMonth(fechaInicio.getMonth() + plazoMeses);
      fechaFin.setDate(fechaFin.getDate() - 1);
      const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
      const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
      const contenidosUnitario = negocio.incluye_contenidos ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;
      // ── Modo "facturado real" ──
      const cuotasFacturadas = getCuotasFacturadasPorMes(negocio, selectedYear);
      if (cuotasFacturadas) {
        cuotasFacturadas.forEach((slot, m) => {
          if (slot.gestion === 0 && slot.contenidos === 0) return;
          let ingresoLocal = 0;
          if (slot.gestion > 0 && gestionUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              gestionUnitario * pantallas * slot.gestion,
              negocio.moneda_gestion,
              "Chile",
              negocio.id,
              m + 1,
              selectedYear,
              slot.fechaFactura
            );
          }
          if (slot.contenidos > 0 && contenidosUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              contenidosUnitario * pantallas * slot.contenidos,
              negocio.moneda_contenidos,
              "Chile",
              negocio.id,
              m + 1,
              selectedYear,
              slot.fechaFactura
            );
          }
          mapa[m] += ingresoLocal;
        });
        return;
      }
      for (let m = 0; m < 12; m++) {
        const ultimoDiaMes = new Date(selectedYear, m + 1, 0);
        if (fechaInicio <= ultimoDiaMes) {
          const fechaParaUF = ultimoDiaMes.toISOString().split("T")[0];
          let ingresoLocal = 0;
          if (gestionUnitario > 0) {
            ingresoLocal += convertirAMonedaLocal(
              gestionUnitario * pantallas,
              negocio.moneda_gestion,
              "Chile",
              negocio.id,
              m + 1,
              selectedYear,
              fechaParaUF
            );
          }
          if (contenidosUnitario > 0 && contenidosVigenteEnMes(negocio, selectedYear, m)) {
            ingresoLocal += convertirAMonedaLocal(
              contenidosUnitario * pantallas,
              negocio.moneda_contenidos,
              "Chile",
              negocio.id,
              m + 1,
              selectedYear,
              fechaParaUF
            );
          }
          mapa[m] += ingresoLocal;
        }
      }
    });
    return mapa;
};

export const ingresosGestionContenidosMensualPeruHistorico = ({ negocios, selectedYear, dolarMensualPeru, dolarFallback }) => {
    const mapa = Array(12).fill(0);
    // Conversión a PEN bound a Perú. No se reutiliza convertirAMonedaLocal de ER/index.js porque
    // esa función usa getDolarValue del país del usuario, no del negocio.
    const toPEN = (monto, moneda, mes) => {
      if (!monto) return 0;
      const m = (moneda || "PEN").toUpperCase();
      if (m === "USD" || m === "US$") return monto * (dolarMensualPeru[mes] || dolarFallback["Perú"]);
      // PEN directo. UF/CLP no deberían aparecer en negocios Perú (data entry inválido);
      // se tratan como PEN defensivamente para no inflar valores como en el bug UF+CLP de Chile.
      return monto;
    };
    negocios.forEach((negocio) => {
      if (negocio.eliminada || negocio.estado !== "Activo" || !negocio.fecha_inicio) return;
      const fechaInicio = fechaLocalDeNegocio(negocio.fecha_inicio);
      const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
      if (plazoMeses === 0) return;
      const fechaFin = new Date(fechaInicio);
      fechaFin.setMonth(fechaInicio.getMonth() + plazoMeses);
      fechaFin.setDate(fechaFin.getDate() - 1);
      const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
      const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
      const contenidosUnitario = negocio.incluye_contenidos ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;
      // ── Modo "facturado real": si meses_facturacion tiene entries, asignar al mes de facturafecha ──
      const cuotasFacturadas = getCuotasFacturadasPorMes(negocio, selectedYear);
      if (cuotasFacturadas) {
        cuotasFacturadas.forEach((slot, m) => {
          if (slot.gestion === 0 && slot.contenidos === 0) return;
          let ingresoLocal = 0;
          if (slot.gestion > 0 && gestionUnitario > 0) {
            ingresoLocal += toPEN(gestionUnitario * pantallas * slot.gestion, negocio.moneda_gestion, m);
          }
          if (slot.contenidos > 0 && contenidosUnitario > 0) {
            ingresoLocal += toPEN(
              contenidosUnitario * pantallas * slot.contenidos,
              negocio.moneda_contenidos || negocio.moneda_gestion,
              m
            );
          }
          mapa[m] += ingresoLocal;
        });
        return;
      }
      for (let m = 0; m < 12; m++) {
        const ultimoDiaMes = new Date(selectedYear, m + 1, 0);
        if (fechaInicio <= ultimoDiaMes) {
          let ingresoLocal = 0;
          if (gestionUnitario > 0) {
            ingresoLocal += toPEN(gestionUnitario * pantallas, negocio.moneda_gestion, m);
          }
          if (contenidosUnitario > 0 && contenidosVigenteEnMes(negocio, selectedYear, m)) {
            ingresoLocal += toPEN(
              contenidosUnitario * pantallas,
              negocio.moneda_contenidos || negocio.moneda_gestion,
              m
            );
          }
          mapa[m] += ingresoLocal;
        }
      }
    });
    return mapa;
};
